import React, { useEffect, useState } from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  LabelList,
  Legend
} from "recharts";
import { PrAnalysisApi } from "../../../../../../api/Api";
import { FaCrosshairs } from 'react-icons/fa';
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import logo from '../../../../../../assets/img/logos/LT2logo.jpeg';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';

import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useTheme,
  CardActions,
  Button
} from "@mui/material";
// import PrAnalysisTab2 from "./PrAnalysisTab2";


// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
  const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  const tenDaysAgo = new Date(date);
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  return {
    Today: formattedCurrentDate,
    LastDay: formattedTenDaysAgo,
  };
}

const Tab8LogContent = () => {


  const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
  const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);


  const theme = useTheme();
  const { palette, spacing, shape: { borderRadius } } = useTheme()

  // Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [logData, setLogData] = useState([])
  const [loading, setLoading] = useState(true);

  // console.log("startdate", StartDate)
  // console.log("enddate", EndDate)
  const credentials = {
    USER: localStorage.getItem("LoginID") || "",
    LCODE: localStorage.getItem("LCODE") || "",
    PASS_KEY: localStorage.getItem("PASS_KEY") || "XYZ",
    WEB_KEY: localStorage.getItem("WEB_KEY") || "WEBXYZ321",
    DT1: StartDate, // Default Start Date
    DT2: EndDate, // Default End Date
  };

  // Fetch data from the API
  const fetchLogData = async () => {
    setLoading(false);
    try {
      const res = await PrAnalysisApi(credentials);


      if (res?.data && Array.isArray(res.data)) {
        console.log("Fetched Data:", res.data);
        setLogData(res.data);



      } else {
        console.error("Data structure mismatch:", res);

      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  // Fetch data on component mount
  // useEffect(() => {
  //   fetchLogData();
  // }, [StartDate, EndDate]);

  useEffect(() => {
    fetchLogData();
  }, []);


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(logData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Define keys to exclude (you can also define keys to include instead)
  const excludeKeys = ["NO", "KWP", "KW_MAX", "KW_MAX_DATE", "USER"]; // Replace "key1", "key2" with actual keys you don't want to export

  // Filter logData
  const filteredLogData = logData.map((item) => {
    const filteredItem = {};
    Object.keys(item).forEach((key) => {
      if (!excludeKeys.includes(key)) {
        filteredItem[key] = item[key]; // Include keys not in excludeKeys
      }
    });
    return filteredItem;
  });

  // Get table headers from filteredLogData
  const tableHeaders = filteredLogData.length > 0 ? Object.keys(filteredLogData[0]) : [];

  // Export to Excel
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredLogData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Plant Generation");
    XLSX.writeFile(wb, `Plant Generation To ${EndDate.replace(" ", "T")} Plant Generation.xlsx`);
  };

  
  

  // Export to PDF
  const exportToPDF = () => {
    const doc = new jsPDF({ orientation: 'landscape', format: [300, 700] });

    // Add Logo (x, y, width, height)
    const imgWidth = 30;  // Adjust width
    const imgHeight = 20; // Adjust height
    const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
    doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

    // Add Title or Text Below the Logo
    const title = `Plant Generation To ${EndDate.replace(" ", "T")}`;
    doc.setFontSize(12);  // Adjust font size
    doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

    // Adjust Y position for the table to start below the text
    let startY = 50;  // Push table further down below text

    doc.autoTable({
      head: [tableHeaders],
      body: currentData.map((item) => tableHeaders.map((key) => item[key])),
      startY: startY,  // Start table below the logo and text
      theme: "grid",
    });

    doc.save(`Plant Generation To ${EndDate.replace(" ", "T")} Plant Generation`);
  };

  

  // Handle Start Date change
  const handleStartDateChange = (value) => {
    setStartDate(value); // Update the StartDate directly
  };

  // Handle End Date change
  const handleEndDateChange = (value) => {
    setEndDate(value); // Update the EndDate directly
  };

  // Refresh data only when clicking "Show"
  function onRefreshData() {
    if (StartDate.length !== 0 && EndDate.length !== 0) {
      fetchLogData(); // Fetch data only after clicking the button
    } else {
      alert("Please provide valid dates");
    }
  }

  return (
    <Box bgcolor={"black"} py={0}>

      <Grid container spacing={spacing(0)} flexGrow={1} sx={{ mt: 0 }}>
        <Grid key="chart-grid" item xs={12}>
          <Card>
            <CardActions sx={{
              display: "flex", // Enable flexbox
              justifyContent: "flex-end", // Align items to the right
              alignItems: "center", // Center items vertically
              gap: "16px", // Add some spacing between the inputs
            }}>
              <label>

                <input
                  type="date"
                  value={StartDate} // Use StartDate directly
                  onChange={(e) => handleStartDateChange(e.target.value)}
                  style={{
                    padding: "2px 2px",
                    borderRadius: "14px",
                    border: "1px solid #ccc",
                  }}
                />
              </label>
              <label>
                To
                <input
                  type="date"
                  value={EndDate} // Use EndDate directly
                  onChange={(e) => handleEndDateChange(e.target.value)}
                  style={{
                    padding: "2px 2px",
                    borderRadius: "14px",
                    border: "1px solid #ccc",
                  }}
                />
              </label>
              {/* <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button> */}
              <IconButton
                onClick={onRefreshData}
                sx={{
                  color: 'black',
                  // backgroundColor: palette.tintBlue,
                  borderRadius: borderRadius,
                  p: 1, // Adjust padding if needed
                }}
              >
                <RefreshIcon sx={{ fontSize: '24px' }} />
              </IconButton>
            </CardActions>
          </Card>
        </Grid>


      </Grid>


      <div style={{ padding: "0", marginTop: "0" }}>
        {/* Controls */}
        <div className="row">
          <div className="col-md-12">
            <div style={containerStyle} className="head">
              <p style={responsiveHeaderStyle}>PR Analysis</p>
              <div style={responsiveControlsStyle}>

                <button onClick={fetchLogData} style={buttonStyle}>
                  Show
                </button>
                <button onClick={exportToExcel} style={exportButtonStyle}>
                  Excel
                </button>
                <button onClick={exportToPDF} style={exportButtonStyle2}>
                  PDF
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Table */}
        <div className="table-responsive">
          <table className="table table-hover table-bordered">
            <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
              <tr>
                <th style={tableHeading}> Date </th>
                <th style={tableHeading}>Energy[kWh]</th>
                <th style={tableHeading}> CUF </th>
                <th style={tableHeading}> PR </th>
                <th style={tableHeading}> Capacity[kW]</th>
                <th style={tableHeading}>Specific Yield</th>
                <th style={tableHeading}> Solar Insolation[kWh/m²/day]</th>
                <th style={tableHeading}>Expected Generation[kWh]</th>
                <th style={tableHeading}>Peak Radiation[W/m²] </th>
                <th style={tableHeading}>Peak Radiation Time </th>


              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={tableHeaders.length} className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, rowIndex) => (
                  <tr key={rowIndex}>

                    <td className="text-center align-middle" style={tableBody}>
                      {item.DATET || ""}
                    </td>

                    <td className="text-center align-middle" style={tableBody}>
                      {item.ENG || ""}
                    </td>

                    <td className="text-center align-middle" style={tableBody}>
                      {item.CUF || ""}
                    </td>
                    <td className="text-center align-middle" style={tableBody}>
                      {item.PR || ""}
                    </td>
                    <td className="text-center align-middle" style={tableBody}>
                      {item.CAP || ""}
                    </td>
                    <td className="text-center align-middle" style={tableBody}>
                      {item.Specific_Yield || ""}
                    </td>
                    <td className="text-center align-middle" style={tableBody}>
                      {item.Solar_Insolation || ""}
                    </td>

                    <td className="text-center align-middle" style={tableBody}>
                      {item.Expected_Generation || ""}
                    </td>

                    <td className="text-center align-middle" style={tableBody}>
                      {item.PEAK_RADIATION || ""}
                    </td>

                    <td className="text-center align-middle" style={tableBody}>
                      {item.PEAK_RADIATION_DATE || ""}
                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={tableHeaders.length} className="text-center align-middle">
                    No data available
                  </td>
                </tr>

              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {/* <div style={{ textAlign: "right", marginTop: "0px" }}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={paginationButtonStyle}
          >
            Previous
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => handlePageChange(index + 1)}
              style={{
                ...paginationButtonStyle,
                backgroundColor: currentPage === index + 1 ? "#007bff" : "#007bff",
                color: currentPage === index + 1 ? "#fff" : "#fff",
              }}
            >
              {index + 1}
            </button>
          ))}
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={paginationButtonStyle}
          >
            Next
          </button>
        </div> */}

          {/* Pagination */}
          <div style={{ textAlign: "right", marginTop: "0px" }}>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={paginationButtonStyle}
            >
              Previous
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => handlePageChange(index + 1)}
                style={{
                  ...paginationButtonStyle,
                  backgroundColor: currentPage === index + 1 ? "#356E35" : "white",
                  color: currentPage === index + 1 ? "#fff" : "#356E35",
                }}
              >
                {index + 1}
              </button>
            ))}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={paginationButtonStyle}
            >
              Next
            </button>
          </div>

      </div>

    </Box>
  );
};

export default Tab8LogContent;



/* Styles */

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  // marginBottom: "7px",
  border: "1px solid lightgray",
  padding: "3px",
  // borderRadius: "7px"
};

const responsiveHeaderStyle = {
  fontWeight: "bold",
  margin: "0",
  display: "flex",
  flexWrap: "wrap"
};

const responsiveControlsStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  justifyContent: "center",
};

const inputStyle = {
  padding: "2px 2px",
  borderRadius: "14px",
  border: "1px solid #ccc",
  // marginLeft: "5px",
  // fontSize: "10px",
};

const buttonStyle = {
  backgroundColor: "#007BFF",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "2px 9px",
  cursor: "pointer",
  fontSize: "10px",
};

const exportButtonStyle = {
  backgroundColor: "darkblue",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "3px 9px",
  cursor: "pointer",
  fontSize: "11px",
};

const exportButtonStyle2 = {
  backgroundColor: "#f44336",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "3px 9px",
  cursor: "pointer",
  fontSize: "11px",
};

const paginationButtonStyle = {
  backgroundColor: "white",
  color: "#007bff",
  border: "1px solid #ddd",
  padding: "5px 10px",
  borderRadius: "5px",
  margin: "0 5px",
  cursor: "pointer",
  fontSize: "14px",
};


const tableHeading = {
  color: "rgb(53, 110, 53)",
  padding: "12px 10px",
  fontSize: "14px",
  whiteSpace: "nowrap",
}

const tableBody = {
  padding: "5px",
  whiteSpace: "nowrap",
}